export enum ProductItemTypeEnum {
    GOLD = 'gold',
    CARD = 'card',
    GEM = 'gem',
    NO_ADS = 'no-ads',
    SUBSCRIBE = 'subscribe',
    AVATAR = 'avatar',
    TOONTINTITEM = 'toon-tint-item',
}

export enum ItemCardProductTypeEnum {
    CARD = 'card',
    CARD_CATEGORY = 'cardCategory',
}
